import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ClientNotesPage} from "./-page/client-notes.page";
import {ClientNotesPending} from "./-page/client-notes.pending";
import {clientNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/clients/$clientId/notes/")({
  component: RouteComponent,
  pendingComponent: ClientNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => clientNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {clientId} = useParams({strict: false}) as {clientId: string};
  const {includeDeleted} = Route.useSearch();

  return <ClientNotesPage clientId={clientId} includeDeleted={includeDeleted} />;
}
